import {
	useEffect,
	useState,
} from 'react';
import {
	IoIosArrowDown,
} from 'react-icons/io';
import Typography, {
	TypographyType,
} from '../typography/karim/Typography';
import {
	Colors,
} from 'utils/color/ColorPalette'
import Button, {
	ButtonColor,
} from '../button';
import './datepicker.scss';

interface DatePickerPlaceHolderProps {
	initialDate?: Date,
	onChange?: (selectedDate: Date) => void,
}

const DatePickerPlaceHolder = ({
	initialDate = new Date(),
	onChange,
}: DatePickerPlaceHolderProps) => {
	const [chosenDate, setChosenDate] = useState<Date>(new Date(initialDate.setHours(0, 0, 0, 0)));

	const changeSelectedDate = (add: boolean) => {
		const newDate = new Date(chosenDate);
		setChosenDate(new Date(newDate.setDate(newDate.getDate() + (add ? 1 : -1))));
	}

	useEffect(() => {
		if (onChange) {
			onChange(chosenDate);
		}
	}, [onChange, chosenDate]);

	return (
		<div className="date-picker-container">
			<div>
				<Button
 					className="date-picker-icon"
					color={ButtonColor.NONE}
					onClick={() => changeSelectedDate(false)}
				>
					<IoIosArrowDown
						size={'28px'}
						color={Colors.neutrals.tints.gy400.hex}
						style={{
							transform: 'rotate(90deg)',
						}}/>
				</Button>
			</div>
			<div>
				<Typography
					type={TypographyType.headingsH5}
					style={{
						color: Colors.blue.shades.b900.hex,
					}}
				>{chosenDate.toLocaleDateString('nb-NO', {
						year: '2-digit', month: '2-digit', day: '2-digit',
					})}
				</Typography>
			</div>
			<div>
				<Button
				 	className="date-picker-icon"
					color={ButtonColor.NONE}
					onClick={() => changeSelectedDate(true)}
				>
					<IoIosArrowDown
						size={'28px'}
						color={Colors.neutrals.tints.gy400.hex}
						style={{
							transform: 'rotate(-90deg)',
						}}
					/>
				</Button>
			</div>
		</div>
	);
}

export default DatePickerPlaceHolder;